"use strict";

import {
  default as React,
  Component,
} from 'react';

import * as D3Shape from 'd3-shape'
import {pieProps} from '../commonProps';

export default class Pie extends Component {
  constructor (props) {
    super(props);
  }

  static defaultProps = {
    onMouseOver: (d) => {},
    onMouseOut: (d) => {},
    ...pieProps
  }

  triggerOver(data , e) {
    this.props.onMouseOver(e, data)
  }

  triggerOut(data, e) {
    this.props.onMouseOut(e, data)
  }

  mkSeries() {
    const {
      data,
      chartSeries,
      value,
      name,
      categoricalColors
    } = this.props;

    let chartSeriesData = chartSeries.map((f, i) => {

      // set a color if not set
      if(!f.color)
        f.color = categoricalColors(i);

      // set name if not set
      if(!f.name)
        f.name = f.field;

      let val;

      data.forEach((d) => {
        if(name(d) === f.field)
          val = d;
      })

      return Object.assign(f, {value: value(val)});
    })

    return chartSeriesData;
  }

  _mkPie () {
    let {
      width,
      height,
      innerRadius,
      outerRadius,
      pieSort,
      value,
      radius,
      pieTextShow
    } = this.props;

    const that = this
    radius = this.props.radius || Math.min(width - 100, height - 100) / 2;
    outerRadius = outerRadius || (radius - 10)
    let labelr = radius + 10;

    let chartSeriesData = this.mkSeries();

    let arc = D3Shape.arc()
      .outerRadius(outerRadius)
      .innerRadius(innerRadius);

    let arcOver = D3Shape.arc()
      .outerRadius(outerRadius + 10)
      .innerRadius(innerRadius);

    let pie = D3Shape.pie()
      .sort((a, b) => { return pieSort(a.value, b.value)})
      .value((d) => { return d.value; })

    return (
      <g className="arc">
        {
          pie(chartSeriesData).map((slice, i) => {
            let textTransform = (d) => {
              let c = arc.centroid(d),
                x = c[0],
                y = c[1],
                // pythagorean theorem for hypotenuse
                h = Math.sqrt( x * x + y * y);

              return "translate(" + (x / h * labelr) +  ',' +
                 (y / h * labelr) +  ")";
            }

            let textAnchor = (d) => {
              return (d.endAngle + d.startAngle)/2 > Math.PI ?
                "end" : "start";
            }

            return (
              <g key={i}>
                <path
                  d={arc(slice)}
                  style={{fill: slice.data.color, stroke: '#FFF', ...slice.data.style}}
                  onMouseOut={that.triggerOut.bind(this, slice)}
                  onMouseOver={that.triggerOver.bind(this, slice)}
                  />
                {
                  pieTextShow? (
                    <text
                      transform={textTransform(slice)}
                      dy=".35em"
                      textAnchor={textAnchor(slice)}
                    >
                      {slice.data.name}
                    </text>
                  ): null
                }
              </g>
            )
          })
        }
      </g>
    )
  }

  render() {

    const{
      width,
      height,
      margins
    } = this.props;

    let t = `translate(${(width - margins.left - margins.right) / 2},  ${(height - margins.top - margins.bottom) / 2})`;
    let pie = this._mkPie();

    return (
      <g transform={t}>
        {pie}
      </g>
    )
  }
}
